import { Workspaces as UserWorkspaces } from '../administration/workspaces';

const Workspaces = () => <UserWorkspaces />;

export default Workspaces;
